// extracted by mini-css-extract-plugin
export default {"root":"CrMqLROyXY","icon":"UskZ9jXTRK","nameBlock":"fMQEMZkFup","name":"yhwaGJ2oft"};